/* eslint-disable camelcase */
import * as yup from "yup"
import React, { useCallback, useMemo, useRef, useState } from "react"
import _ from "lodash"
import moment from "moment"
import { Appearance, TextInput, TouchableOpacity, ViewStyle, Dimensions } from "react-native"
import { Cycle, Farm } from "../../../database"
import { DateTimePickerField } from "../../field/date-time-picker-field/date-time-picker-field"
import { FormProps } from "../form"
import { Formik } from "formik"
import { Icon, View } from "native-base"
import { JalaIcon } from "../../jala-icon/jala-icon"
import { ModelField } from "../../field/model-field/model-field"
import { NumeralField } from "../../field/numeral-field/numeral-field"
import { Text } from "../../text/text"
import { color, nativeBaseTheme } from "../../../theme"
import { observer } from "mobx-react-lite"
import { translate } from "../../../i18n"
import { WalkthroughElement } from "../../walkthrough-element/walkthrough-element"

const windowWidth = Dimensions.get('window').width;

const FORM_DROPDOWN: ViewStyle = {
  paddingHorizontal: 16,
  // marginBottom: 8,
  paddingBottom: 8,
  backgroundColor: color.palette.white
}

const TITLE: ViewStyle = {
  borderTopWidth: 1,
  borderColor: color.palette.background,
  paddingHorizontal: 16,
  paddingTop: 16,
  paddingBottom: 10
}

const BORDER: ViewStyle = {
  backgroundColor: color.palette.background,
  height: 4
}

const OTHERS: ViewStyle = {
  width: windowWidth,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingHorizontal: 16,
  // marginBottom: 14,
  marginTop: 14,
  paddingTop: 14,
  paddingBottom: 14,
  backgroundColor: color.palette.white
}

export interface ChemicalMultiMeasurementFormProps extends FormProps {
  /**
   * An optional style override useful for padding & margin.
   */
  initialValues?: {
    farm_id?: number,
    pond_id?: number,
    cycle_id?: number,
    measured_date?: string,
    measured_time?: string,
    ammonia?: number,
    nitrat?: number,
    nitrit?: number,
    alkalinity?: number,
    hardness?: number,
    calcium?: number,
    magnesium?: number,
    carbonat?: number,
    bicarbonat?: number,
    tom?: number,
    ammonium?: number,
    phosphate?: number,
    total_ammonia?: number,
    potassium?: number,
  }
}

/**
 * Describe your component here
 */
export const ChemicalMultiMeasurementForm = observer(function ChemicalMultiMeasurementForm(props: ChemicalMultiMeasurementFormProps) {
  const {
    initialValues: initialValuesProps = {},
    onSubmit: onSubmitProps,
    colorScheme = Appearance.getColorScheme(),
    innerRef,
    parentScrollViewRef: scrollViewRef,
    ...rest
  } = props

  const [ isHide, setHide ] = useState<boolean>(true)

  const input = {
    // farm_id: useRef<TextInput>(),
    // cycle_id: useRef<TextInput>(),
    // measured_date: useRef<TextInput>(),
    // measured_time: useRef<TextInput>(),

    ammonia: useRef<TextInput>(),
    nitrit: useRef<TextInput>(),
    alkalinity: useRef<TextInput>(),
    nitrat: useRef<TextInput>(),
    hardness: useRef<TextInput>(),
    calcium: useRef<TextInput>(),
    magnesium: useRef<TextInput>(),
    carbonat: useRef<TextInput>(),
    bicarbonat: useRef<TextInput>(),
    tom: useRef<TextInput>(),
    ammonium: useRef<TextInput>(),
    phosphate: useRef<TextInput>(),
    total_ammonia: useRef<TextInput>(),
    potassium: useRef<TextInput>(),
  }

  const nextInput = {
    // farm_id: () => input.cycle_id.current && input.cycle_id.current.focus(),
    // cycle_id: () => input.measured_date.current && input.measured_date.current.focus(),
    // measured_date: () => input.measured_time.current && input.measured_time.current.focus(),
    // measured_time: () => input.ammonia.current && input.ammonia.current.focus(),
    ammonia: () => input.nitrit.current && input.nitrit.current.focus(),
    nitrit: () => input.alkalinity.current && input.alkalinity.current.focus(),
    alkalinity: () => input.nitrat.current && input.nitrat.current.focus(),
    nitrat: () => input.hardness.current && input.hardness.current.focus(),
    hardness: () => input.calcium.current && input.calcium.current.focus(),
    calcium: () => input.magnesium.current && input.magnesium.current.focus(),
    magnesium: () => input.carbonat.current && input.carbonat.current.focus(),
    carbonat: () => input.bicarbonat.current && input.bicarbonat.current.focus(),
    bicarbonat: () => input.tom.current && input.tom.current.focus(),
    tom: () => input.ammonium.current && input.ammonium.current.focus(),
    ammonium: () => input.phosphate.current && input.phosphate.current.focus(),
    phosphate: () => input.total_ammonia.current && input.total_ammonia.current.focus(),
    total_ammonia: () => input.potassium.current && input.potassium.current.focus(),
    // potassium: null,

  }

  const validationSchema = yup.object({
    farm_id: yup.number().nullable().required().label(translate("chemicalMultiMeasurementForm.farmId")),
    cycle_id: yup.number().nullable().required().label(translate("chemicalMultiMeasurementForm.cycleId")),
    measured_date: yup.mixed().nullable().required().label(translate("chemicalMultiMeasurementForm.measuredDate")),
    measured_time: yup.mixed().nullable().required().label(translate("chemicalMultiMeasurementForm.measuredTime")),

    ammonia: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.ammonia")),
    nitrit: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.nitrit")),
    alkalinity: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.alkalinity")),
    nitrat: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.nitrat")),
    hardness: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.hardness")),
    calcium: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.calcium")),
    magnesium: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.magnesium")),
    carbonat: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.carbonat")),
    bicarbonat: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.bicarbonat")),
    tom: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.tom")),
    ammonium: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.ammonium")),
    phosphate: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.phosphate")),
    total_ammonia: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.totalAmmonia")),
    potassium: yup.number().nullable().label(translate("chemicalMultiMeasurementForm.potassium")),
  }).test(function (value) {
    const isValid = !![
      'ammonia', 'nitrit', 'alkalinity', 'nitrat', 'hardness', 'calcium', 'magnesium', 'carbonat', 'bicarbonat', 'tom', 'ammonium', 'phosphate', 'total_ammonia', 'potassium',
    ].find((k) => value[k])
    if (isValid) return true;
    else return this.createError({
      path: 'ammonia|nitrit|alkalinity|nitrat|hardness|calcium|magnesium|carbonat|bicarbonat|tom|ammonium|phosphate|total_ammonia|potassium',
      message: ''
    })
  })

  const onSubmit = useCallback((values) => {
    onSubmitProps({
      ...values,
      measured_at: values.measured_date
        && values.measured_time
        && moment(`${values.measured_date} ${values.measured_time}`).format('YYYY-MM-DDTHH:mm:ssZ')
        || null,
    })
  }, [onSubmitProps])

  const initialValues = useMemo<ChemicalMultiMeasurementFormProps["initialValues"]>(() => ({
    farm_id: null,
    pond_id: null,
    cycle_id: null,
    measured_date: moment().format('YYYY-MM-DD'),
    measured_time: moment().startOf('minutes').format('HH:mm:ss'),
    ..._.omit(initialValuesProps, 'measured_at')
  }), [initialValuesProps])

  const iconName = isHide ? "expand_more" : "expand_less"

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      innerRef={innerRef}
      {...rest}
    >
      {({ values, initialValues, setFieldValue, setFieldTouched }) => (
        <>
          <ModelField
            name="farm_id"
            txPrefix="chemicalMultiMeasurementForm"
            colorScheme={colorScheme}
            formControlProps={{ isRequired: true }}
            modelPickerProps={{
              Model: Farm,
              isDisabled: !!initialValues.farm_id,
              onValueChange: async (value) => {
                await setFieldValue('cycle_id', null)
                await setFieldValue('pond_id', null)
                await setFieldValue('farm_id', value || null)
                await setFieldTouched('farm_id')
              }
            }}
          />
          <View style={TITLE}>
            <Text tx="chemicalMultiMeasurementForm.chemical" preset="title3" colorScheme={colorScheme} />
          </View>
          <View style={BORDER} />
          <WalkthroughElement
            id="chemical-form-first"
            scrollViewRef={scrollViewRef}
            scrollOffset={250}
          >
            <ModelField
              key={`${values.farm_id}-cycle_id`}
              name="cycle_id"
              txPrefix="chemicalMultiMeasurementForm"
              colorScheme={colorScheme}
              formControlProps={{ isRequired: true }}
              modelPickerProps={{
                Model: Cycle,
                dataLabel: "pond_name",
                fetchData: (model, search) => (
                  model.fetch({
                    farm_id__eq: values.farm_id,
                    sort: 'started_at,desc|pond_name_alpha_numeric'
                  }).then((models) => models.filter((m) => (
                    `${m.pond_name} - ${moment(m.started_at).format("DD MMM YYYY")}${m.finished_at ? ` (${translate("Finished")})` : ""}`
                  ).toLowerCase().includes((search || '').toLowerCase())))
                ),
                renderSelectedItemText: (item) => item && `${item.pond_name} - ${moment(item.started_at).format("DD MMM YYYY")}${item.finished_at ? ` (${translate("Finished")})` : ""}`,
                clearable: true,
                isDisabled: !values.farm_id || !!initialValues.cycle_id,
                onValueChange: async (value, index, item) => {
                  await setFieldValue('pond_id', (item || {}).pond_id || null)
                  await setFieldValue('cycle_id', value || null)
                  await setFieldTouched('cycle_id')
                },
                titleTx: "chemicalMultiMeasurementForm.cycleIdPlaceholder"
              }}
            />
            <DateTimePickerField
              name="measured_date"
              txPrefix="chemicalMultiMeasurementForm"
              colorScheme={colorScheme}
              formControlProps={{ isRequired: true }}
            />
            <View flexDirection="row">
              <DateTimePickerField
                name="measured_time"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                formControlProps={{ flex: 1, isRequired: true }}
                dateTimePickerProps={{ dateTimePickerProps: { mode: "time" } }}
              />
              <View
                flex={1}
                style={FORM_DROPDOWN}
              ></View>
            </View>
            <NumeralField
              name="ammonia"
              txPrefix="chemicalMultiMeasurementForm"
              colorScheme={colorScheme}
              input={input}
              nextInput={nextInput}
            />
            <NumeralField
              name="nitrit"
              txPrefix="chemicalMultiMeasurementForm"
              colorScheme={colorScheme}
              input={input}
              nextInput={nextInput}
            />
            <NumeralField
              name="alkalinity"
              txPrefix="chemicalMultiMeasurementForm"
              colorScheme={colorScheme}
              input={input}
              nextInput={nextInput} />
          </WalkthroughElement>
          <WalkthroughElement
            id="chemical-form-second"
            scrollViewRef={scrollViewRef}
            scrollOffset={250}
          >
            <View style={OTHERS} >
              <Text tx="waterQualityMultiMeasurementForm.otherParameters" preset="title3" color={color.palette.gray800} />
              <TouchableOpacity onPress={() => setHide(!isHide)}>
                <Icon {...nativeBaseTheme.components.Icon.baseStyle({ colorMode: colorScheme })}
                      as={<JalaIcon name={iconName} />} size="24px" />
              </TouchableOpacity>
            </View>
          </WalkthroughElement>
          {!isHide &&
            <>
              <NumeralField
                name="nitrat"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                input={input}
                nextInput={nextInput}
              />
              <NumeralField
                name="hardness"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                input={input}
                nextInput={nextInput} />
              <NumeralField
                name="calcium"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                input={input}
                nextInput={nextInput} />
              <NumeralField
                name="magnesium"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                input={input}
                nextInput={nextInput} />
              <NumeralField
                name="carbonat"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                input={input}
                nextInput={nextInput} />
              <NumeralField
                name="bicarbonat"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                input={input}
                nextInput={nextInput} />
              <NumeralField
                name="tom"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                input={input}
                nextInput={nextInput} />
              <NumeralField
                name="ammonium"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                input={input}
                nextInput={nextInput} />
              <NumeralField
                name="phosphate"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                input={input}
                nextInput={nextInput} />
              <NumeralField
                name="total_ammonia"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                input={input}
                nextInput={nextInput} />
              <NumeralField
                name="potassium"
                txPrefix="chemicalMultiMeasurementForm"
                colorScheme={colorScheme}
                input={input}
                nextInput={nextInput} />
            </>
          }
        </>
      )}
    </Formik>
  )
})

ChemicalMultiMeasurementForm.displayName = 'ChemicalMultiMeasurementForm'
